<template>
    <div class="card">
        <div class="card-header" :id="elementHeaderId">
            <button class="btn btn-block unfocus text-center text-nowrap" type="button" data-toggle="collapse"
                :data-target="`#${elementCollapseId}`" :aria-expanded="expanded" :aria-controls="elementCollapseId">
                {{ title }}
            </button>
        </div>

        <div :id="elementCollapseId" class="collapse" :class="{'show': expanded}" :aria-labelledby="elementHeaderId">
            <div class="card-body">
                <component
                    v-bind:is="componentForm"
                    v-model="value"
                    :panelCfg="panelCfg"
                    :baseTranslateID="baseTranslateID"
                    :labelDateFormat="labelDateFormat"
                    :dateFormat="dateFormat"
                    :readonlyForm="readonlyForm"
                    :vScope="vScope"
                    :lists="lists"
                    />
            </div>
        </div>
    </div>
</template>

<script>
import ElementAdvancedSearchMixin from "../mixins/ElementAdvancedSearchMixin";

export default {
    mixins: [
        ElementAdvancedSearchMixin,
    ],
    components: {
        OccupationSearchForm: () => import(/* webpackChunkName: "cemeteries-searchoccupationform" */ './../forms/OccupationSearchForm'),
        DeedOwnerSearchForm: () => import(/* webpackChunkName: "cemeteries-searchdeedownerform" */ './../forms/DeedOwnerSearchForm'),
        IntermentSearchForm: () => import(/* webpackChunkName: "cemeteries-searchintermentform" */ './../forms/IntermentSearchForm'),
    },
    props: {
        expanded: {
            type: Boolean,
            default: false
        },
        elementName: {
            type: String,
            require: true
        },
        lists: {
            type: Object,
            default: () => {
                return {};
            }
        },
    },
    data() {
        return {
        }
    },
    computed: {
        title() {
            return this.$t(`${this.baseTranslateID}.title`);
        },
        elementHeaderId() {
            return `${this.elementName}Heading`;
        },
        elementCollapseId() {
            return `${this.elementName}Collapse`;
        },
        componentForm() {
            return `${this.elementName}SearchForm`;
        }
    },
    methods: {

    }
}
</script>

<style lang="scss" scoped>
.card {
    --border-radius: 16px;

    border: 1px solid rgba(24, 20, 41, .2) !important;
    box-sizing: border-box;
    border-radius: var(--border-radius);
    margin-bottom: 32px;

    .card-header {
        border-radius: var(--border-radius);
        background: none;
        padding: 0;
        border: none;

        .btn {
            font-size: 20px;
            line-height: 24px;
            padding: 16px;
            border-radius: var(--border-radius);

            &:hover:not([aria-expanded=true]) {
                background: rgba(0, 0, 0, .04);
            }
        }
    }
}
</style>